<template>
    <div>
        <compFormEdit
            ref="formbase"
            class="margin-layout"
            :formdata="getBase"
            v-model="formData"
            :labelWidth="100"
        ></compFormEdit>
        <div class="pic-title">
            <div class="pic-text"><span class="star">*</span>图片上传</div>
            <div class="demo-upload-list" v-for="item in uploadList">
                <template v-if="item.status === 'finished'">
                    <img :src="item.url" />
                    <div class="demo-upload-list-cover">
                        <Icon
                            type="ios-eye-outline"
                            @click.native="handleView(item.url)"
                        ></Icon>
                        <Icon
                            type="ios-trash-outline"
                            @click.native="handleRemove(item, uploadList)"
                        ></Icon>
                    </div>
                </template>
                <template v-else>
                    <Progress
                        v-if="item.showProgress"
                        :percent="item.percentage"
                        hide-info
                    ></Progress>
                </template>
            </div>
            <Upload
                ref="upload"
                name="multipartFile"
                :show-upload-list="false"
                :on-success="handleSuccess"
                :format="['jpg', 'jpeg', 'png', 'gif']"
                :max-size="10240"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                :before-upload="handleBeforeUpload"
                :data="result"
                multiple
                type="drag"
                :action="uploadCompressUrl"
                :headers="headers"
                style="display: inline-block; width: 58px"
            >
                <div style="width: 58px; height: 58px; line-height: 58px">
                    <Icon type="ios-camera" size="20"></Icon>
                </div>
            </Upload>
            <input
                type="hidden"
                ref="pictures"
                v-model="formData.pictures"
                style="width: 200px"
            />
        </div>
        <Modal v-model="modalProps.show" v-bind="modalProps">
            <img style="width: 600px; height: auto" :src="modalProps.url" />
        </Modal>
        <vButtonGroup class="text-right">
            <vButton @click="submit" theme="primary">{{
                $t("global.modal.confirm", { defaultValue: "确定" })
            }}</vButton>
            <vButton @click="cancel">{{
                $t("global.common.cancel", { defaultValue: "取消" })
            }}</vButton>
        </vButtonGroup>
        <vLoading loading size="large" transfer v-if="loading"></vLoading>
    </div>
</template>

<script>
import { HttpGetActivityProcessEditStatus } from "@/service/products/activityProcess";

export default {
    props: ["activeids", "querytype"],
    created() {},
    data() {
        return {
            id: this.activeids.ids,
            status: this.activeids.status,
            cancelStatus: this.activeids.cancelStatus,
            activityType: this.activeids.activityType,
            loading: false,
            formData: {},
            uploadList: [],
            uploadCompressUrl:
                process.env.VUE_APP_APIURL_UC + "/api/v1/BizAttach/uploadFile",
            headers: {
                Authorization: "Bearer " + global.AUTH_TOKEN,
            },
            modalProps: {
                show: false,
                title: this.$t("global.photo.info", {
                    defaultValue: "图片信息",
                }),
                footerHide: true,
                width: 636,
                height: 636,
                zIndex: 9999,
                url: "",
            },
            previewImgPath: "", //预览图片链接
            previewVisible: false, //预览显示
            result: {
                srcLabel: this.activeids.ids || 0,
                contextId: global.SYSID,
                model: "changeLabel",
                type: "other",
            },
            pictureList: [], //扩展字段，图片数组
            docList: [],
        };
    },
    computed: {
        isAdd() {
            return this.type === "add";
        },
        getBase() {
            let reject = this.querytype == "reject";
            let success = this.querytype == "success";
            let cancelSuccess = this.querytype == "cancelSuccess";
            let cancelReject = this.querytype == "cancelReject";
            return [
                {
                    label: "失败原因",
                    key: "failureReason",
                    span: 24,
                    show: reject || cancelReject,
                    required: true,
                    tag: "vTextarea",
                },
                {
                    label: "实际折扣金额(or%):",
                    show: success,
                    required: false,
                    key: "actualDiscountAmount",
                },
                {
                    label: "实际折扣后价格:",
                    show: success,
                    required: false,
                    key: "actualDiscountedPrice",
                },
                {
                    label: "Promation ID:",
                    show: success,
                    required: this.activityType == 0 ? false : true,
                    key: "promationId",
                },
                {
                    label: "Agreement ID:",
                    show: success,
                    required: this.activityType == 0 ? false : true,
                    key: "agreementId",
                },
                {
                    label: success ? "提报反馈" : "取消反馈",
                    key: "remark",
                    span: 24,
                    show: success || cancelSuccess,
                    required: true,
                    tag: "vTextarea",
                },
            ];
        },
    },
    methods: {
        handleView(url) {
            this.modalProps.show = true;
            this.modalProps.url = url;
        },
        //删除图片
        handleRemove(file, uploadList) {
            //页面上删除图片
            const fileList = uploadList;
            let fIndex = fileList.indexOf(file);
            uploadList.splice(fIndex, 1);
            let imgs = new Array();
            for (let i = 0; i < uploadList.length; i++) {
                imgs.push(uploadList[i].url);
            }
            this.pictureList = imgs;
            this.formData.pictures = imgs.join(",");
        },
        handleSuccess(res, file) {
            if (res.data != "") {
                let img = res.data.genUrl;
                file.url = img;
                this.pictureList.push(img);
                this.formData.pictures = this.pictureList.join(",");
            }
        },
        handleFormatError(file) {
            this.$Notice.warning({
                title: "不支持的图片格式",
                desc:
                    "所选图片‘ " +
                    file.name +
                    " ’格式不正确, 请选择 .jpg .jpeg .png .gif格式图片",
            });
        },
        handleMaxSize(file) {
            this.$Notice.warning({
                title: "图片大小过大",
                desc:
                    "所选图片‘ " +
                    file.name +
                    " ’大小过大, 不得超过 5M.前往https://tinypng.com进行图片压缩",
            });
        },
        handleBeforeUpload(file) {
            const check = this.uploadList.length < 5;
            if (!check) {
                this.$Notice.warning({
                    title: "只能上传5张图片.",
                });
            }
            file.status = "finished";
            return check;
        },
        isDecimalNumber(value) {
            // 检查是否为有效数字（整数或小数）
            return !isNaN(parseFloat(value)) && isFinite(value);
        },
        async submit() {
            let bool3 = await this.$refs.formbase.validate();
            if (!bool3) {
                return;
            }
            this.loading = true;
            this.formData.ids = this.id;
            this.formData.status = this.status;
            this.formData.cancelStatus = this.cancelStatus;
            this.formData.pictures = this.pictureList.join(",");
            if (this.querytype == "success") {
                if (
                    this.formData.actualDiscountAmount != null &&
                    this.formData.actualDiscountAmount != "" &&
                    !this.isDecimalNumber(this.formData.actualDiscountAmount)
                ) {
                    this.loading = false;
                    this.$Message.error("实际折扣金额请入有效的数字!");
                    return;
                } else if (
                    this.formData.actualDiscountAmount != null &&
                    this.formData.actualDiscountAmount != "" &&
                    !this.isDecimalNumber(this.formData.actualDiscountedPrice)
                ) {
                    this.loading = false;
                    this.$Message.error("实际折扣后价格请输入有效的数字！");
                    return;
                }
            }
            if (this.formData.pictures == null) {
                this.loading = false;
                this.$Message.error("图片未上传!");
                return;
            }
            let ids = [];
            ids.push(this.formData.ids);
            this.formData.ids = ids;
            this.uploadList.splice(0, this.uploadList.length);
            HttpGetActivityProcessEditStatus({
                ...this.formData,
            }).then(
                (res) => {
                    this.loading = false;
                    this.$VMessage.success(res.message);
                    this.success();
                },
                (err) => {
                    this.loading = false;
                    this.$VMessage.error(err.message);
                }
            );
        },
        success() {
            this.$emit("on-close");
            this.$emit("on-update");
            this.$emit("refreshPage");
        },
        cancel() {
            this.$emit("on-close");
        },
    },
    mounted() {
        this.uploadList = this.$refs.upload.fileList;
        window.console.log("querytype", this.querytype);
    },
};
</script>
<style>
/**
 * 图片上传
 */
.demo-upload-list {
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    margin-right: 4px;
}
.demo-upload-list img {
    width: 100%;
    height: 100%;
}
.demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
}
.demo-upload-list:hover .demo-upload-list-cover {
    display: block;
}
.demo-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
}
.pic-title {
    margin-left: 35px;
}
.pic-text {
    font-size: 13px;
    font-weight: bold;
    margin-bottom: 15px;
}
.star {
    color: red;
    font-weight: 100;
    margin-right: 5px;
}
</style>
